import { useContext, useCallback, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import PropTypes from 'prop-types';
import { Box, Divider, MenuItem, MenuList, Popover, Typography } from '@mui/material';
import { getDatabase, push, ref, set } from "firebase/database";
import { AuthContext, validate_shopify_connection } from "components";
import { logout } from "../../firebase";

const db = getDatabase()

export const AccountPopover = (props) => {
  const { anchorEl, onClose, open } = props;
  const navigate = useNavigate();
  const { currentUser, account, updateSquareIntegration } = useContext(AuthContext);

  useEffect(() => {
    if (!account) return;

    if (window.location.pathname === '/shopify_success') {
      const searchParams = new URLSearchParams(window.location.search);
      const integration_id = searchParams.get('shop').split('.')[0]
      if (searchParams.has('token') && searchParams.has('shop')) {
        validate_shopify_connection({
          "shopify_store": integration_id,
          "token": searchParams.get('token'),
          "shopify_domain": searchParams.get('shop'),
        }).then(() => {
          navigate('/settings')
        }).catch(() => {
          // TODO Handle the error gracefully
          console.log("Something went wrong")
        })

      }
    }

    if (window.location.pathname === '/square_success') {
      const searchParams = new URLSearchParams(window.location.search);
      const access_token = searchParams.get('access_token')
      const refresh_token = searchParams.get('refresh_token')
      const expires_at = searchParams.get('expires_at')

      updateSquareIntegration({
        access_token,
        refresh_token,
        expires_at,
      }, () => {
        navigate('/settings')
      })
      // console.log('access_token', access_token)
      // console.log('refresh_token', refresh_token)
      // console.log('expires_at', expires_at)
      // navigate('/settings')
    }
  }, [account])

  const handleSignOut = useCallback(
    () => {
      onClose?.();
      logout()
      navigate('login');
      // Force reload to clear all data
      setTimeout(function() {
        // eslint-disable-next-line no-self-assign
        window.location.href = window.location.href;
      }, 50)
    },
    [onClose, navigate]
  );

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom'
      }}
      onClose={onClose}
      open={open}
      PaperProps={{ sx: { width: 200 } }}
    >
      <Box
        sx={{
          py: 1.5,
          px: 2
        }}
      >
        <Typography variant="overline">
          Account
        </Typography>
        <Typography
          color="text.secondary"
          variant="body2"
        >
          { currentUser.displayName || currentUser.email }
        </Typography>
      </Box>
      <Divider />
      <MenuList
        disablePadding
        dense
        sx={{
          p: '8px',
          '& > *': {
            borderRadius: 1
          }
        }}
      >
        <MenuItem onClick={handleSignOut}>
          Sign out
        </MenuItem>
      </MenuList>
    </Popover>
  );
};

AccountPopover.propTypes = {
  anchorEl: PropTypes.any,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired
};